<!-- 更多床位信息 -->
<template>
  <div class="main yy">
    <div class="BedInformation" :id="BedInformation">
      <div class="BedInformation_box">
        <div class="BedInformation_title">
          <div class="BedInformation_title_">
            <div class="BedInformation_button" v-if="BedInformation">
              <!-- <span class="spannone" @click="nullFunClick1">
                				<span v-if="checkedListType1" class="spannone1">{{ buttonTextType1 ? "全部床位" : "未选中床位" }}</span>
                				<span v-else class="spannone1" id="nb">
									<span>{{ this.checkedListTex1 }}</span>等共{{ this.checkedList1.length }}个床位
								</span>
                				<div class="spannoneDiv1" v-if="nullFunmsg1">
                  					<div style="display: flex; justify-content: start; width: 100%">
										<a-checkbox
											:indeterminate="indeterminate1"
											:checked="checkAll1"
											@change="lllChange"
										>
											{{ this.checkedList1.length }}/{{ this.plainOptions1.length }}床
										</a-checkbox>
										<span @click="getNull1">清空</span>
									</div>
									<a-checkbox-group @change="onChanges1" v-model="checkedList1">
										<a-col v-for="item in plainOptions1" :key="item.bedId">
											<a-checkbox :value="item.bedId">{{ item.bedName }}</a-checkbox>
										</a-col>
									</a-checkbox-group>
									<div class="butt">
										<a-button @click.stop="bedChoiceErr">取消</a-button>
										<a-button type="primary" @click.stop="bedChoice">确定</a-button>
									</div>
								</div>
              				</span> -->
              <a-range-picker
                class="timeChange"
                format="YYYY-MM-DD"
                :disabled-date="disabledDate"
                :default-value="[
                  new Date()
                    .toLocaleDateString()
                    .replace('/', '-')
                    .replace('/', '-'),
                  new Date()
                    .toLocaleDateString()
                    .replace('/', '-')
                    .replace('/', '-'),
                ]"
                :placeholder="['开始时间', '结束时间']"
                @openChange="onOpenChange"
                @calendarChange="onCalendarChange"
                @change="onChangeTimer"
                inputReadOnly
              >
                <a-icon type="calendar" slot="suffixIcon" />
              </a-range-picker>
              <span class="spannone" @click="nullFunClick">
                <span v-if="checkedListType" class="spannone1">{{
                  buttonTextType ? "全部事件" : "未选中事件"
                }}</span>
                <span v-else class="spannone1">
                  <span class="firstSpan" v-if="this.checkedList.length > 1" :title="checkedListTex">{{
                    this.checkedListTex
                  }}</span>
                  <span class="firstSpan" v-if="this.checkedList.length == 1" style="width:auto">{{
                    this.checkedListTex.split('"')[1]
                  }}</span>
                  <span v-if="this.checkedList.length > 1"
                    >等{{ this.checkedList.length }}类事件</span
                  >
                </span>
                <div class="spannoneDiv" v-if="nullFunmsg">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    "
                  >
                    <a-checkbox
                      :indeterminate="indeterminate"
                      :checked="checkAll"
                      @change="lllChange1"
                    >
                      {{ this.checkedList.length }}/{{
                        this.plainOptions.length
                      }}类
                    </a-checkbox>
                    <span @click="getNull">清空</span>
                  </div>
                  <a-checkbox-group @change="onChanges" v-model="checkedList">
                    <a-col v-for="item in plainOptions" :key="item.id">
                      <a-checkbox :value="item.key">{{
                        item.value
                      }}</a-checkbox>
                    </a-col>
                  </a-checkbox-group>
                  <div class="butt">
                    <a-button @click="typeChoiceErr">取消</a-button>
                    <a-button type="primary" @click="typeChoice">确定</a-button>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
        <a-spin :spinning="spinning" tip="加载中" :delay="100">
          <div class="wirgin" v-if="!this.SocketBedInformation.length > 0">
            {{ bedInfo }}
          </div>
          <div
            class="BedInformation_contont"
            v-else
            :id="BedInformation ? 'BedInformation_contonts' : ''"
          >
            <div
              class="BedInformation_contont_text"
              v-for="(item, index) in SocketBedInformation"
              v-show="item.content !== '用户状态变化为离床'"
              :key="index"
            >
              <span :class="item.isStress == 1 ? 'red' : ''">{{
                item.time
              }}</span>
              <span
                :class="item.isStress == 1 ? 'red' : ''"
                :style="{
                  display: item.name ? 'inline-block' : 'none',
                }"
                >{{ item.name ? item.name : "" }}</span
              >
              <span :class="item.isStress == 1 ? 'red' : ''">{{
                item.content
              }}</span>
            </div>
          </div>
        </a-spin>
      </div>
      <br />
      <br />
      <br />
      <div class="pagesType">
        <a-pagination
          :defaultPageSize="20"
          :current="pageNum"
          :default-current="pageNum"
          :total="total"
          @change="onShowSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
const defaultCheckedList = [];
const defaultCheckedList1 = [];
import moment from "moment";
import "moment/locale/zh-cn";
export default {
  data() {
    return {
      moment,
      BedInformation: "BedInformations",
      SocketBedInformation: [], //最新消息床位
      checkedListType: true,
      checkedListType1: true,
      buttonTextType: true,
      buttonTextType1: true,
      checkedListTex: "",
      checkedListTex1: "",
      checkedList1: defaultCheckedList1,
      nullFunmsg: false,
      nullFunmsg1: false,
      indeterminate1: true,
      indeterminate: true,
      checkAll1: true,
      checkAll: true,
      plainOptions1: [],
      checkedList: defaultCheckedList,
      plainOptions: [],
      dateString: [], //选择时间
      pageNum: 1, // 当前页
      total: 20,
      jiluZT: [],
      jiluZT1: [],
      disabledCurrent: null, //禁用时间的变量
      spinning: true,
      bedInfo: "",
    };
  },
  created() {},
  mounted() {
    this.checkedList = [];
    this.checkedList1 = [];
    this.getEventFilterOption();
    let time = new Date()
      .toLocaleDateString()
      .replace("/", "-")
      .replace("/", "-");
    this.dateString.push(time, time);
    console.log(this.dateString[0].split("-"), "this.dateString");
    setTimeout(() => {
      this.getbedChoice();
    }, 2000);
  },
  methods: {
    /**
     * 清空禁用时间段的设置
     */
    onOpenChange(status) {
      // 清空禁用时间段的设置
      this.disabledCurrent = null;
    },
    /**
     * 获取手动选择的时间段起始值
     */
    onCalendarChange(dates) {
      console.log("From: ", dates[0], ", to: ", dates[1]);
      // 获取手动选择的时间段起始值
      this.disabledCurrent = dates[0];
    },
    /**
     * 时间控制切换赋值
     */
    onChangeTimer(moment, data) {
      //this.fromTime = data[0];
      //this.toTime = data[1];
      this.dateString = data;
      this.pageNum = 1;
      this.getbedChoice();
    },
    /**
     * 1、时间限制范围 开始时间~结束时间不能超过31天
     */
    disabledDate(current) {
      if (!this.disabledCurrent) return current > moment().startOf(1, "day");

      return (
        (current && current > moment().startOf(1, "day")) ||
        current <
          moment(this.disabledCurrent).subtract(1, "M").startOf("day") ||
        current > moment(this.disabledCurrent).add(1, "M").endOf("day")
      );
    },
    lllChange(e) {
      if (this.checkAll1) {
        this.checkAll1 = false;
        this.checkedList1 = [];
      } else {
        this.checkAll1 = true;
        this.checkedList1 = [];
        this.plainOptions1.forEach((item) => {
          //事件类型默认全选
          this.checkedList1.push(item.bedId);
        });
      }
    },
    lllChange1(e) {
      if (this.checkAll) {
        this.checkAll = false;
        this.checkedList = [];
      } else {
        this.checkAll = true;
        this.checkedList = [];
        this.plainOptions.forEach((item) => {
          //事件类型默认全选
          this.checkedList.push(item.key);
        });
      }
    },
    //事件选择
    nullFunClick1() {
      if (
        event.target.className == "spannone" ||
        event.target.className == "spannone1"
      ) {
        this.nullFunmsg1 = this.nullFunmsg1 ? false : true;
        this.typeChoiceErr();
        if (this.jiluZT1.length > 0) {
          this.indeterminate1 = true;
        } else {
          this.indeterminate1 = false;
        }
        if (this.jiluZT1.length == this.plainOptions1.length) {
          this.checkAll1 = true;
          this.indeterminate1 = false;
        } else {
          this.checkAll1 = false;
          this.indeterminate1 = false;
        }
        this.nullFunmsg = false;
        this.jiluZT1 = JSON.parse(JSON.stringify(this.checkedList1));
      }
    },
    //选择床位确定事件
    bedChoice() {
      if (this.dateString.length < 1) {
        this.$message.error("请选择时间范围！！！");
        return;
      }
      this.nullFunmsg1 = false;
      let text = [];
      if (this.plainOptions1 && this.plainOptions1.length > 1) {
        this.plainOptions1.forEach((item) => {
          this.checkedList1.forEach((i) => {
            if (item.bedId == i) {
              text.push(item.bedName);
            }
          });
        });
        this.checkedListTex1 = JSON.stringify(text).split("[")[1].split("]")[0];
      } else if (this.plainOptions1 && this.plainOptions1.length == 1) {
        this.checkedListTex1 = this.plainOptions1[0].bedName;
      }
      if (this.checkedList1.length == this.plainOptions1.length) {
        this.buttonTextType1 = true;
        this.checkedListType1 = true;
      } else if (this.checkedList1.length == 0) {
        this.buttonTextType1 = false;
        this.checkedListType1 = true;
      } else if (
        this.checkedList1.length > 1 &&
        this.checkedList1.length != this.plainOptions1.length
      ) {
        this.checkedListType1 = false;
      }
      this.jiluZT1 = JSON.parse(JSON.stringify(this.checkedList1));
      this.getbedChoice();
    },
    //取消选择床位
    bedChoiceErr() {
      this.checkedList1 = this.jiluZT1;
      this.nullFunmsg1 = false;
    },
    //清空事件
    getNull1() {
      this.checkedList1 = [];
    },
    //选择床位或选择类型之后请求接口
    getbedChoice() {
      if (this.dateString.length < 1 || this.dateString[0] == "") {
        this.$message.error("请选择时间范围！！！");
        return;
      }
      this.spinning = true;
      let bedIds = "";
      if (this.checkedList1.length == this.plainOptions1.length) {
        bedIds = "";
      } else if (
        this.checkedList1.length > 0 &&
        this.checkedList1.length != this.plainOptions1.length
      ) {
        bedIds = JSON.stringify(this.checkedList1).split("[")[1].split("]")[0];
      } else if (this.checkedList1.length == 0) {
        bedIds = 0;
      }
      let a = null;
      if (this.dateString[0].split("-")[1].length < 2) {
        a = "0" + this.dateString[0].split("-")[1];
      } else {
        a = this.dateString[0].split("-")[1];
      }
      let b = null;
      if (this.dateString[0].split("-")[2].length < 2) {
        b = "0" + this.dateString[0].split("-")[2];
      } else {
        b = this.dateString[0].split("-")[2];
      }
      let a1 = null;
      if (this.dateString[1].split("-")[1].length < 2) {
        a1 = "0" + this.dateString[1].split("-")[1];
      } else {
        a1 = this.dateString[1].split("-")[1];
      }
      let b1 = null;
      if (this.dateString[1].split("-")[2].length < 2) {
        b1 = "0" + this.dateString[1].split("-")[2];
      } else {
        b1 = this.dateString[1].split("-")[2];
      }
      let endDate = this.dateString[1].split("-")[0] + "-" + a1 + "-" + b1; //结束时间
      let pageNum = this.pageNum;
      let pageSize = 20;
      let startDate = this.dateString[0].split("-")[0] + "-" + a + "-" + b; //开始时间
      let typeIds = "";
      if (this.checkedList.length == this.plainOptions.length) {
        typeIds = "";
      } else if (
        this.checkedList.length > 0 &&
        this.checkedList.length != this.plainOptions.length
      ) {
        typeIds = JSON.stringify(this.checkedList).split("[")[1].split("]")[0];
      } else if (this.checkedList.length == 0) {
        typeIds = 0;
      }

      this.$get(
        "/api/event/search?bedIds=" +
          this.$route.query.bedId +
          "&onlyBed=1" +
          "&endDate=" +
          endDate +
          "&startDate=" +
          startDate +
          "&pageNum=" +
          pageNum +
          "&pageSize=" +
          pageSize +
          "&typeIds=" +
          typeIds,
        "",
        (res) => {
          this.spinning = false;
          this.total = res.data.total;
          if (res.data.records && res.data.records.length > 0) {
            this.SocketBedInformation = res.data.records;
            this.bedInfo = "";
          } else {
            this.SocketBedInformation = [];
            this.bedInfo = "暂无床位信息";
          }
          console.log(res, "ccccccccc");
        },
        (err) => {
          this.spinning = false;
          this.bedInfo = "";
          console.log(err);
        }
      );
    },
    onChanges1(checkedList) {
      this.indeterminate1 =
        !!checkedList.length && checkedList.length < this.plainOptions1.length;
      this.checkAll1 = checkedList.length === this.plainOptions1.length;
    },
    //获取事件类型
    getEventFilterOption() {
      this.$get(
        "/api/event/eventFilterOption?onlyBed=1",
        {},
        (res) => {
          if (!res.data) {
            return;
          }
          this.plainOptions = res.data;
          //事件类型默认全选
          res.data.forEach((item) => {
            this.checkedList.push(item.key);
          });
          this.jiluZT = JSON.parse(JSON.stringify(this.checkedList));
        },
        (err) => {
          console.log(err);
        }
      );
      //   		this.$get("/api/bed/nameList", {}, (res) => {
      // if (!res.data) {
      // 	return;
      // }
      //       		this.plainOptions1 = res.data;
      // //事件类型默认全选
      // res.data.forEach((item) => {
      // 	this.checkedList1.push(item.bedId);
      // });
      //       		this.jiluZT1 = JSON.parse(JSON.stringify(this.checkedList1));
      //     	}, (err) => {
      //       		console.log(err);
      //     	});
    },
    //取消选择类型
    typeChoiceErr() {
      this.checkedList = this.jiluZT;
      this.nullFunmsg = false;
    },
    //选择类型
    typeChoice() {
      if (this.dateString && this.dateString.length < 1) {
        this.$message.error("请选择时间范围！！！");
        return;
      }
      this.nullFunmsg = false;
      let text = [];
      if (this.plainOptions && this.plainOptions.length > 1) {
        this.plainOptions.forEach((item) => {
          this.checkedList.forEach((i) => {
            if (item.key == i) {
              text.push(item.value);
            }
          });
        });
        this.checkedListTex = JSON.stringify(text).split("[")[1].split("]")[0];
      } else if (this.plainOptions && this.plainOptions.length == 1) {
        this.checkedListTex = this.plainOptions[0].bedName;
      }
      if (this.checkedList.length == this.plainOptions.length) {
        this.buttonTextType = true;
        this.checkedListType = true;
      } else if (this.checkedList.length == 0) {
        this.buttonTextType = false;
        this.checkedListType = true;
      } else if (
        this.checkedList.length >= 1 &&
        this.checkedList.length != this.plainOptions.length
      ) {
        this.checkedListType = false;
      }
      this.jiluZT = JSON.parse(JSON.stringify(this.checkedList));
      this.pageNum = 1;
      this.getbedChoice();
    },
    //废弃的日期切换事件
    onChange(date, dateString) {
      let sDate1 = Date.parse(dateString[0]);
      let sDate2 = Date.parse(dateString[1]);
      let dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      let iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      if (iDays > 31) {
        this.$message.error("所选时间间隔不得超过31天！！！");
        return false;
      }
      this.dateString = dateString;
      this.getbedChoice();
    },
    //事件选择
    nullFunClick() {
      if (
        event.target.className == "spannone" ||
        event.target.className == "spannone1" ||
        event.target.className == "firstSpan"
      ) {
        this.nullFunmsg = this.nullFunmsg ? false : true;
        this.bedChoiceErr();
        if (this.jiluZT.length > 0) {
          this.indeterminate = true;
        } else {
          this.indeterminate = false;
        }
        if (this.jiluZT.length == this.plainOptions.length) {
          this.checkAll = true;
          this.indeterminate = false;
        } else {
          this.checkAll = false;
          this.indeterminate = false;
        }
        this.nullFunmsg1 = false;
        this.jiluZT = JSON.parse(JSON.stringify(this.checkedList));
      }
    },
    //清空事件
    getNull() {
      this.checkedList = [];
      this.checkAll = false;
    },
    onChanges(checkedList) {
      this.indeterminate =
        !!checkedList.length && checkedList.length < this.plainOptions.length;
      this.checkAll = checkedList.length === this.plainOptions.length;
    },
    onShowSizeChange(e) {
      this.pageNum = e;
      this.getbedChoice();
    },
  },
};
</script>
<style lang="scss">
.main {
  width: 100%;
  height: 100%;
}
.BedInformation {
  width: 100%;
  height: 100%;
  margin-top: 20px;
  padding-bottom: 40px;
  .pagesType {
    position: fixed;
    bottom: 40px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
  }
  .BedInformation_box {
    width: 1180px;
    margin: auto;
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12) !important;
    border-radius: 8px;
    padding: 30px 20px 40px 20px !important;
    background: #ffffff;
    .BedInformation_title {
      width: 100%;
      margin-left: -10px;
      .BedInformation_title_ {
        padding: 10px 0 10px 0;
        display: flex;
        align-items: center;
        width: 1180px;
        margin: auto;
      }
      .BedInformation_button {
        display: flex;
        align-items: center;
        .spannone {
          padding: 0 10px 0 10px;
          height: 32px;
          background: #e6f7ff;
          border-radius: 2px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #1890ff;
          margin-left: 10px;
          cursor: pointer;
          position: relative;
          #nb {
            span:first-child {
              width: 150px !important;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .spannone1 {
            display: flex;
            span:first-child {
              width: 80px;
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .spannoneDiv {
            position: absolute;
            width: 176px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            overflow: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 5px 12px 5px 12px;
            z-index: 10;
            .butt {
              width: 90%;
              position: absolute;
              bottom: 0;
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              padding-bottom: 10px;
              button {
                margin-right: 10px;
              }
            }
            .ant-checkbox-wrapper {
              display: flex;
              align-items: center;
            }
            .ant-checkbox-group {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              width: 100%;
              padding-bottom: 60px;
              .ant-col {
                margin-top: 10px;
              }
            }
          }
          .spannoneDiv1 {
            position: absolute;
            width: 920px;
            height: 219px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            overflow: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 5px 12px 5px 12px;
            .butt {
              width: 98%;
              position: absolute;
              bottom: 0;
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              padding-bottom: 10px;
              button {
                margin-right: 10px;
              }
            }
            .ant-checkbox-wrapper {
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }
            .ant-checkbox-group {
              display: flex;
              flex-wrap: wrap;
              align-items: flex-start;
              width: 100%;
              max-height: 250px;
              overflow: auto;
              .ant-col {
                margin-top: 10px;
              }
            }
          }
        }
        .timeChange {
          width: 240px !important;
          height: 32px;
          margin-left: 10px;
          background: #e6f7ff !important;
          span,
          input,
          input::-webkit-input-placeholder,
          .ant-calendar-range-picker-input {
            color: #1890ff !important;
            background: #e6f7ff !important;
            border: none !important;
          }
        }
      }
      .looknone1 {
        font-size: 18px;
        font-weight: 500;
        color: #262626;
      }
      .looknone {
        font-size: 14px;
        font-weight: 400;
        color: #1890ff;
        margin-left: 10px;
        line-height: 24px;
        cursor: pointer;
      }
    }
    .wirgin {
      font-size: 14px;
      font-weight: 400;
      color: #262626;
    }
    .BedInformation_contont {
      width: 100%;
      padding-bottom: 10px;
      .BedInformation_contont_text {
        width: 100%;
        display: flex;
        margin-top: 12.5px;
        .red {
          color: red !important;
        }
        span {
          margin-left: 10px;
          font-size: 14px;
          font-weight: 400;
          color: #262626;
        }
        span:nth-child(2) {
          width: 214px;
        }
        span:first-child {
          margin-left: 0;
          width: 190px;
        }
      }
    }
  }
}
</style>